module.exports = __webpack_public_path__ + "static/media/joel-filipe-RFDP7_80v5A-unsplash.81000cd3.png";